<template>
  <v-dialog max-width="700" :value="dialog" @input="$emit('update:dialog')">
    <v-card max-width="700">
      <v-card-title class="dialog_header">{{ formTitle }}</v-card-title>
      <v-card-text>
        <formWrapper :validator="$v.form">
          <v-form @submit.prevent="handleSubmit">
            <v-row>
              <v-col cols="12" class="mt-5">
                <locale-select
                  v-if="isEdit"
                  v-model="locale"
                  @change="changeLocale"
                />
              </v-col>
              <v-col cols="12">
                <span>{{ $t("labels.photo") }}</span>
                <section class="file-upload">
                  <new-image-upload
                    :isPngImage="isPngImage"
                    class="file-upload__image"
                    :imgUrl="form.photo ? form.photo.path : ''"
                    :imgId="form.photo ? form.photo.id : ''"
                    @fileSelected="onFileChange($event, 'photo')"
                    :checkRatio="false"
                    :maxSize="iconSize"
                    :reset="reset"
                    @ImageUpdated="onImageUpdate"
                  />
                </section>
              </v-col>
              <v-col cols="12">
                <span>{{ $t("labels.bg_photo") }}</span>
                <section class="file-upload">
                  <new-image-upload
                    class="file-upload__image"
                    :imgUrl="form.bg_photo ? form.bg_photo.path : ''"
                    @fileSelected="onFileChange($event, 'bg_photo')"
                    :checkRatio="false"
                    :maxSize="photoSize"
                    :reset="reset"
                  />
                </section>
              </v-col>
              <v-col cols="12">
                <form-group name="name" attribute="fields.name">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      dense
                      v-bind="attrs"
                      v-on="listeners"
                      outlined
                      v-model="form.name"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12" md="6">
                <v-label>{{ $t("fields.color") }}</v-label>
                <form-group name="color" attribute="fields.color">
                  <template slot-scope="{ attrs, listeners }">
                    <v-color-picker
                      mode="hexa"
                      hide-mode-switch
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.color"
                      :value="form.color"
                    ></v-color-picker>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12" md="6">
                <v-label>{{ $t("fields.bg_color") }}</v-label>
                <form-group name="bg_color" attribute="fields.bg_color">
                  <template slot-scope="{ attrs, listeners }">
                    <v-color-picker
                      mode="hexa"
                      hide-mode-switch
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="form.bg_color"
                      :value="form.bg_color"
                    ></v-color-picker>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12" md="6">
                <form-group
                  :validator="$v.form.priority"
                  name="priority"
                  attribute="fields.priority"
                >
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      type="number"
                      dense
                      v-bind="attrs"
                      v-on="listeners"
                      outlined
                      v-model="form.priority"
                    ></v-text-field>
                  </template>
                </form-group>
              </v-col>
              <v-col cols="12" md="6" class="mx-auto">
                <v-switch
                  :label="$t('table.visible')"
                  true-value="1"
                  false-value="0"
                  v-model="form.visible"
                ></v-switch>
              </v-col>

              <v-col cols="12">
                <v-btn
                  type="submit"
                  :disabled="$v.form.$invalid"
                  block
                  class="primary"
                  large
                  rounded
                  :loading="loading"
                >
                  <v-icon>mdi-send</v-icon>
                  {{ $t("button.save") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </formWrapper>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  minValue
} from "vuelidate/lib/validators";
import { ShowData } from "@/helpers/apiMethods";
export default {
  name: "FormAction",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    slug: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      form: {
        name: "",
        photo: "",
        bg_photo: "",
        bg_color: "",
        color: {},
        visible: "0",
        priority: ""
      },
      iconSize: 2,
      photoSize: 1.24,

      isPngImage: true,
      reset: false,
      locale: this.locale
    };
  },
  computed: {
    formTitle() {
      if (!this.isEdit) {
        return this.$t("button.create");
      } else {
        return this.$t("button.edit");
      }
    }
  },
  methods: {
    onImageUpdate() {
      this.$emit("on-refresh-category");
    },
    handleShowData(locale = "en") {
      ShowData({
        reqName: "trip-categories",
        param: this.slug,
        locale
      })
        .then(res => {
          const data = res.data["trip_category"];

          const {
            name,
            color,
            photo,
            bg_photo,
            bg_color,
            priority,
            visible
          } = data;
          this.form = {
            color,
            photo,
            bg_photo,
            name,
            bg_color,
            priority,
            visible: visible ? "1" : "0"
          };
        })
        .catch(err => console.log(err));
    },
    changeLocale(locale) {
      this.locale = locale;
      this.handleShowData(locale);
    },
    onFileChange({ file }, name) {
      this.form[name] = file;
      this.reset = false;
    },
    onCreate(data) {
      this.$emit("on-create-category", data);
    },
    onUpdate(data) {
      this.$emit("on-update-category", data);
    },
    handleSubmit() {
      this.$emit("update:loading", !this.loading);

      const formData = new FormData();
      if (this.form.photo === "" || (this.form.photo && this.form.photo.id)) {
        delete this.form.photo;
      }
      if (
        this.form.bg_photo === "" ||
        this.form.bg_photo === null ||
        (this.form.bg_photo && this.form.bg_photo.id)
      ) {
        delete this.form.bg_photo;
      }
      if (this.form.bg_photo == "") {
        delete this.form.bg_photo;
      }
      Object.keys(this.form).forEach(formKey => {
        if (formKey === "color" || formKey === "bg_color") {
          !this.isEdit
            ? formData.append(formKey, this.form[formKey].hex)
            : formData.append(formKey, this.form[formKey]);
        } else {
          if (this.form[formKey] !== "")
            formData.append(formKey, this.form[formKey]);
        }
      });

      if (!this.isEdit) {
        // in case create
        this.onCreate(formData);
      } else {
        // in case update
        formData.append("locale", this.locale);
        formData.append("_method", "put");

        this.onUpdate(formData);
      }
    },
    resetData() {
      this.$v.form.$reset();
      Object.keys(this.form).map(formKey => {
        if (formKey === "color" || formKey === "bg_color") {
          return (this.form[formKey] = {});
        } else {
          return (this.form[formKey] = "");
        }
      });
      this.form.visible = "0";
      this.$v.form.$reset();
      this.reset = false;
      setTimeout(() => {
        this.reset = true;
      }, 50);
      this.$emit("update:loading", false);
    }
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(30)
      },
      photo: {
        required
      },
      bg_photo: {
        required
      },
      color: {
        required
      },
      bg_color: {
        required
      },
      priority: {
        minValue: minValue(1)
      }
    }
  },
  watch: {
    dialog: {
      handler(value) {
        if (!value) {
          this.resetData();
        }
      },
      immediate: true
    },
    isEdit: {
      handler(value) {
        if (value) {
          this.handleShowData();
        }
      },
      immediate: true
    }
  }
};
</script>
